import { render } from "./ConnectingPane.vue?vue&type=template&id=63cf8698"
import script from "./ConnectingPane.vue?vue&type=script&lang=js"
export * from "./ConnectingPane.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__